import {Component, OnDestroy} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {LoadingService} from '../_services/loading.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  animations: [
    trigger('preloaderActivate', [
      state('active', style({visibility: 'visible', opacity: 1})),
      state('inactive', style({visibility: 'hidden', opacity: 0})),
      transition('* => active', [
        style({visibility: 'visible', opacity: 1}),
        animate('0.4s'),
      ]),
      transition('active => *', [
        animate('0.4s', style({visibility: 'hidden', opacity: 0})),
      ]),
    ]),
  ],
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})

export class LoadingComponent implements OnDestroy {

  isActive = false;
  mostRecent = '';

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private loadingService: LoadingService,
  ) {
    this.loadingService.onNewLoading()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (newLoading) => {
          this.isActive = newLoading.length > 0;
          this.mostRecent = newLoading[newLoading.length - 1] || '';
        }
      );
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
